import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getUpdatesByTaskId: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/:taskId/taskHistories`
    },
    getContributionDetailHistory: {
        method: 'GET',
        url: `${BASE_PATH_API}/tasks/:taskId/contributionDetailHistory`
    },
    createTaskHistoryV4: {
        method: 'POST',
        url: `${BASE_PATH_API}/v4/taskHistories`
    },
    updateTaskHistoryV3: {
        method: 'PUT',
        url: `${BASE_PATH_API}/v3/taskHistories/:taskHistoryId`
    },
    deletePendingTaskHistory: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/taskHistoryItems/:taskHistoryId`
    },
    deletePendingTaskHistoryAudit: {
        method: 'PUT',
        url: `${BASE_PATH_API}/taskHistoryItems/:taskHistoryId/revertPosting`
    },
    suspendPendingTaskHistoryItem: {
        method: 'PUT',
        url: `${BASE_PATH_API}/taskHistoryItems/:id/suspendPosting`
    },
    resumePendingTaskHistoryItem: {
        method: 'PUT',
        url: `${BASE_PATH_API}/taskHistoryItems/:id/resumePosting`
    },
    resendTaskHistoryItemNotification: {
        method: 'POST',
        url: `${BASE_PATH_API}/v3/taskHistories/:taskHistoryId/emails`
    },
    getRentalOwnerRequestsTaskHistory: {
        method: 'GET',
        url: `${BASE_PATH_API}/tasks/:taskId/rentalOwnerRequests/history`
    },
    createRentalOwnerRequestTaskHistory: {
        method: 'POST',
        url: `${BASE_PATH_API}/tasks/:taskId/rentalOwnerRequests/history`
    },
    getTaskHistories: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/taskHistories/:taskHistoryId`
    },
    getAllTaskActivitiesByTaskId: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/tasks/:taskId/activities`,
    }
};

export function TaskHistoriesApi() {
    return createActions(actions);
}
